import { cx } from '@apparel/react/cx';
import Badge from '@material-ui/core/Badge';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import React, { useMemo } from 'react';

export interface CartIconProps extends React.HTMLAttributes<HTMLSpanElement> {
    loading?: boolean;
    itemsCount?: number;
    icon?: any;
    CircularProgressProps?: CircularProgressProps;
}

export const CartIcon = React.memo((props: CartIconProps) => {
    const { loading, className, itemsCount, icon, CircularProgressProps, ...rest } = props;
    const classes = useStyle(props);

    const icon$ = useMemo(() => icon || <ShoppingCartIcon fontSize={'small'} />, [icon]);

    return (
        <span className={cx(className, classes.root)} {...rest}>
            {loading && (
                <span className={classes.loader}>
                    <CircularProgress size={16} thickness={4} {...CircularProgressProps} />
                </span>
            )}
            {itemsCount || loading ? (
                <Badge className={classes.badge} badgeContent={itemsCount || ''} color={'primary'} showZero>
                    {icon$}
                </Badge>
            ) : (
                icon$
            )}
        </span>
    );
});

const useStyle = makeStyles(
    () => ({
        root: {
            position: 'relative',
            display: 'inline-flex',
            fontSize: 0,
        },

        badge: {
            position: 'relative',
            zIndex: 1,
        },

        loader: {
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            transform: 'translate3d(50%, -50%, 0)',
            top: 0,
            right: 0,
            zIndex: 7,

            '& svg': {
                color: '#fff',
            },
        },
    }),
    {
        name: 'CartIcon',
    },
);

export default CartIcon;
